<template>
    <v-app>
        <router-view></router-view>
        <LoadingComponent v-if="isShowLoading"/>
        <AppServiceView></AppServiceView>
    </v-app>
</template>
<script>
import { mapState } from 'vuex'
import LoadingComponent from '@/components/LoadingComponent'
import '@/assets/css/common.scss'
import AppServiceView from '@/components/AppServiceView'

export default {
    name: 'App',
    components: { LoadingComponent, AppServiceView },
    computed: {
        ...mapState({
            isShowLoading: state => state.isShowLoading
        })
    }
}
</script>
<style>
    html {
        overflow-y: auto !important;
    }
</style>
